import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from "../Routes/HomePage";
import HomePage2 from "../Routes/HomePage2";
import SuccessPage from '../Routes/SuccessPage';
import TermsPage from '../Routes/TermsPage';
import ProfilePage from '../Routes/ProfilePage';
import DeactivateProcessing from '../Routes/DeactivateProcessing';
import DeactivateSuccess from '../Routes/DeactivateSuccess';

const Routing = () => {
    const router=createBrowserRouter([
        {
            path:"/",
            element:<HomePage2 />
        },
        {
          path:"/success",
          element:<SuccessPage />
        },
        {
          path:"/terms",
          element:<TermsPage />
        },
        {
          path:"/profile",
          element:<ProfilePage />
        },
        {
          path:"/deactivation",
          element:<DeactivateProcessing />
        },
        {
          path:"/deactivation-success",
          element:<DeactivateSuccess />
        },
        {
          path:"*",
          element:<Navigate to="/" />
        }
    ])
  return (
    <RouterProvider router={router} />
  )
}

export default Routing